import type { FC, ReactChild } from 'react';
import React from 'react';

import type { ViewerContextualData } from './../../ricos-types/index.js';

type RicosViewerContextProps = {
  contextualData: ViewerContextualData;
  children: ReactChild;
};

type ContextType = Omit<
  ViewerContextualData,
  't' | 'theme' | 'isMobile' | 'experiments' | 'locale' | 'languageDir' | 'textDirection'
>;

export const RicosViewerContext = React.createContext<ContextType>(null as unknown as ContextType);

export const RicosViewerContextProvider: FC<RicosViewerContextProps> = ({
  contextualData: {
    anchorTarget,
    relValue,
    plugins,
    config,
    helpers,
    disabled,
    seoMode,
    iframeSandboxDomain,
    disableRightClick,
    customAnchorScroll,
    textAlignment,
    onNodeClick,
    jsdomMode,
    baseUrl,
    isPrint,
  },
  children,
}) => {
  return (
    <RicosViewerContext.Provider
      value={{
        anchorTarget,
        relValue,
        plugins,
        config,
        helpers,
        disabled,
        seoMode,
        iframeSandboxDomain,
        disableRightClick,
        customAnchorScroll,
        textAlignment,
        onNodeClick,
        jsdomMode,
        baseUrl,
        isPrint,
      }}
    >
      {children}
    </RicosViewerContext.Provider>
  );
};
